import { CourseData } from '@containers/activity-router/data-grid-container/courses/types/courses.types';
import { getActivityKey, getTopicKey } from '@containers/activity-router/routes/helpers/keys/key-generator';
import {
    ActivityId,
    IsGridCellVisible,
    TopicId
} from '@containers/activity-router/routes/helpers/slice/slice.types';
import { ChallengesState } from '@containers/activity-router/routes/learn/challenges/challenges.types';

type GetChallengesIsCellVisibleParams = {
    filteredCourse: CourseData
    filters: Pick<ChallengesState['filters'], 'dok' | 'strand' | 'topic'>
};

// Grid cells cover the level and playlist, so only topic and DOK filters leave cells off screen.
export const getChallengesIsCellVisible = ({
    filteredCourse,
    filters
}: GetChallengesIsCellVisibleParams): IsGridCellVisible | undefined => {
    const hasHidingFilter = filters.dok.length > 0 || filters.strand.length > 0 || filters.topic.length > 0;

    if (!hasHidingFilter) return undefined;

    const visibleActivityKeys = new Map<TopicId, Set<ActivityId>>();

    filteredCourse?.topics.forEach((strand) => {
        strand.topics?.forEach((topic) => {
            visibleActivityKeys.set(
                getTopicKey({
                    strandId: strand.id,
                    topicId: topic.id
                }),
                new Set(topic.activities.map(({ id, activityType }) => getActivityKey({
                    id,
                    activityType
                })))
            );
        });
    });

    return ({ topicKey, activityKey }) => visibleActivityKeys.get(topicKey)?.has(activityKey) ?? false;
};
